// extracted by mini-css-extract-plugin
export default {"text_center":"order-details_text_center__T34oQ","elements_center":"order-details_elements_center__IF45J"};